import { FC } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from '../i18n/useTranslation';

interface AccessDeniedCardProps {
  onRetry: () => void;
}

const AccessDeniedCard: FC<AccessDeniedCardProps> = ({ onRetry }) => {
  const t = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f8f8fa"
      p={3}
    >
      <Card
        sx={{
          maxWidth: 480,
          width: '100%',
          p: 5,
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: '12px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '16px',
            bgcolor: '#fef2f2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}
        >
          <LockIcon sx={{ fontSize: 28, color: '#C24242' }} />
        </Box>
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, mb: 1.5, letterSpacing: '-0.02em', color: 'text.primary' }}
        >
          {t('authGuard.accessDenied.title')}
        </Typography>
        <Typography sx={{ color: 'text.secondary', lineHeight: 1.7, fontSize: '0.95rem' }}>
          {t('authGuard.accessDenied.body')}
        </Typography>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={onRetry}
          sx={{
            'mt': 3,
            'color': 'text.disabled',
            'textTransform': 'none',
            'fontSize': '0.85rem',
            'fontWeight': 400,
            '&:hover': { color: 'text.secondary', bgcolor: 'transparent' },
          }}
        >
          {t('authGuard.tryAgain')}
        </Button>
      </Card>
    </Box>
  );
};

export default AccessDeniedCard;
